// extracted by mini-css-extract-plugin
export default {"navigation":"PaginationComponent_navigation__5DTb9","pageItem":"PaginationComponent_pageItem__j6GxC"};